import React, { useEffect, useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import {
  LargeScreenDrawer,
  SmallScreenDrawer,
} from "./drawer/DrawerComponents";
import MyIcon from "../../assets/global/logo"; // Logo included back
import { useLocation, useNavigate } from "react-router-dom";

interface DrawerItem {
  id: string;
  text: string;
  icon: React.ReactNode;
  path?: string;
  children?: DrawerItem[];
  selectable?: boolean;
}

interface DrawerProps {
  items: DrawerItem[];
  miniMode: boolean;
  onItemClick?: () => void; // New prop to close drawer on mobile
}

const DrawerData: React.FC<DrawerProps> = ({ items, miniMode, onItemClick }) => {
  const theme = useTheme();
  const isMediumOrLarger = useMediaQuery(theme.breakpoints.up("md"));
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null);
  const [openItemId, setOpenItemId] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log(location);
  }, [location]);

  const handleListItemClick = (id: string, path?: string) => {
    setSelectedItemId(id);
    if (path) {
      navigate(path);
    }
    
    if (!isMediumOrLarger && onItemClick) {
      onItemClick(); // Close drawer on mobile
    }
  };

  const toggleOpen = (id: string) => {
    setOpenItemId((prevId) => (prevId === id ? null : id));
  };

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          display: "flex",
          alignContent: "center",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <MyIcon
          style={{
            maxWidth: "100%",
            height: "auto",
            display: "block",
            margin: "1rem",
          }}
        />
      </Box>
      {isMediumOrLarger ? (
        <LargeScreenDrawer
          items={items}
          selectedItemId={selectedItemId}
          openItemId={openItemId}
          handleListItemClick={handleListItemClick}
          toggleOpen={toggleOpen}
          miniMode={miniMode}
        />
      ) : (
        <SmallScreenDrawer
          items={items}
          selectedItemId={selectedItemId}
          openItemId={openItemId}
          handleListItemClick={handleListItemClick}
          toggleOpen={toggleOpen}
        />
      )}
    </Box>
  );
};

export default DrawerData;
